import Box from '@mui/material/Box';

import { LogoBadge } from './logoBadge';
import { PLUGIN_DISPLAY_MAP } from '../../constants/plugins';

export const CloudDisplay = ({
  grayscale = false,
  size = 24,
  value,
}: {
  grayscale?: boolean;
  size?: number;
  value?: string;
}) => {
  if (!value) {
    return null;
  }
  const imageFileName = PLUGIN_DISPLAY_MAP[(value as string)?.toLowerCase() ?? '']?.logo;

  return (
    <Box alignItems="center" display="flex" height="100%" justifyContent="space-around">
      <LogoBadge
        alt={value || ''}
        backgroundColor="none"
        fallbackSrc="/images/default.png"
        grayscale={grayscale}
        height={size}
        imgHeight={size}
        imgWidth={size}
        src={imageFileName ? `/images/${imageFileName}` : '/images/default.png'}
        width={size}
      />
    </Box>
  );
};
